import { makeStyles } from '@material-ui/core';
import colors from '../../styles/colors';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: `${colors.lightGreen2}55`,
    padding: theme.spacing(0.5),

    '& .MuiToggleButtonGroup-groupedSizeSmall': {
      height: 30,
    },

    '@media print': {
      display: 'none',
    },
  },
  btnGroup: {
    marginLeft: 8,
  },
  title: {
    fontSize: 16,
    color: colors.black,
    marginRight: 10,
  },
  rowItem: {
    margin: `0 ${theme.spacing(2)}px`,
  },
}));
